// Header dockning
let lastScrollTop = 0;
const body = document.body;
window.addEventListener('scroll',function(){
    let scrollTop = window.scrollY || document
        .documentElement.scrollTop;
    if (scrollTop > 0){
        body.classList.add('scrolled');
    } else {
        body.classList.remove('scrolled');
    }
});

// Top Menu
function topMenu() {
    jQuery('.menu >.menu-item-has-children').on('mouseenter', function(){
        let submenuHeight = jQuery(this).children('.sub-menu').outerHeight();
        jQuery('.site-header__menu-bg').css({
            'height': submenuHeight,
            'opacity': 1
        });
    }).on('mouseleave', function(){
        let submenuHeight = 0;
        jQuery('.site-header__menu-bg').css({
            'height': submenuHeight,
            'opacity': 0
        });
    })

    // Top menu active for #href
    jQuery('.menu-item.scroll-to').on('click', function(){
        jQuery('.menu-item.scroll-to').removeClass('scroll-to-active');
        jQuery(this).addClass('scroll-to-active');
    })

    // Top menu active for #href from other menu item after reload
    jQuery('.menu-item.scroll-to >a').filter(function() {
        return this.href === location.href
    }).parent().addClass('scroll-to-active');

    // Top menu href="#" disable click
    jQuery('.site-header__navigation > .menu .menu-item a[href="#"]').on('click', function(e) {
        e.preventDefault();
    })

}

topMenu();

// Mobile Menu
document.addEventListener(
    "DOMContentLoaded", () => {

        let selector = '.site-header__navigation';
        if( document.querySelector('body').classList.contains('woocommerce') ) {
            selector = selector + '--mobile-shop';
        }

        new Mmenu(selector, {
            "offCanvas": {
                "position": "left-front"
            },
            "slidingSubmenus": false,
            "theme": "white",
            "navbar": false,
            "navbars": [
                {
                    "position": "bottom",
                    "content": [
                        "<a class='btn mmenu-account btn--secondary' href='" + WLC.myaccount + "'>" + WLC.myaccountname + "</a>"
                    ]
                },
                {
                    "position": "bottom",
                    "content": [
                        "<a class='btn mmenu-cart btn--secondary-outline' href='" + WLC.carturl + "'>" + WLC.cartname + "</a>"
                    ]
                },
            ],
        }, {
            offCanvas: {
                clone: true
            }
        });

    document.querySelector('#mm-1 .current-menu-ancestor')?.classList.add('mm-listitem--opened');

    }
);

jQuery('body').on('added_to_cart', function () {
    window.location = WLC.carturl;
});

// Cart
document.addEventListener("click", function ( event ) { 
    const target = event.target
    if(!target) return;

    if("coupon-code-trigger" !== target.id) return;

    event.target.style.display = "none";
    event.target.nextElementSibling.style.removeProperty("display");
    event.preventDefault();
});


// Countdown Timer
function countdownTimer( element ) {
    let days, hours, minutes, seconds, endDate;

    endDate = new Date(element.dataset.date + 'T' + element.dataset.time ).getTime();

    if (isNaN(endDate)) {
        return;
    }

    setInterval(calculate, 1000);

    function calculate() {
        let startDate = new Date().getTime();

        let timeRemaining = parseInt((endDate - startDate) / 1000);

        if (timeRemaining >= 0) {
            days = parseInt(timeRemaining / 86400);
            timeRemaining = (timeRemaining % 86400);

            hours = parseInt(timeRemaining / 3600);
            timeRemaining = (timeRemaining % 3600);

            minutes = parseInt(timeRemaining / 60);
            timeRemaining = (timeRemaining % 60);

            seconds = parseInt(timeRemaining);

            element.querySelector('.day > span').innerHTML = format( parseInt(days,10) );
            element.querySelector('.hrs > span').innerHTML = format(hours);
            element.querySelector('.min > span').innerHTML = format(minutes);
            element.querySelector('.sec > span').innerHTML = format(seconds);
        } else {
            return;
        }
    }

    function format( value ) {
        let string = value.toString(),
            formatted = '';
        if ( string.length == 1 ) {
            string = '0' + string;
        }
        for ( var i = 0; i < string.length; i++ ) {
            formatted += '<span>' + string[i] + '</span>';
        }
        return formatted;
    }
}

let countdownTimers = document.getElementsByClassName('countdown-timer');
if ( countdownTimers ) {
    Array.from( countdownTimers ).forEach( timer => {
        countdownTimer( timer );
    });
}

// Checkout
const invoiceElement = document.getElementById('billing_faktura');
function handleInvoiceCheckbox() {
    if(!invoiceElement) return;
    const companyRow = document.querySelectorAll('.company-row');
    const heading = $('#invoice-paypo-heading');
    const payPoSelected = $('#payment_method_przelewy24_extra_227').is(':checked');
    const messages = heading.data('messages');
    if(invoiceElement.checked) {
        if(payPoSelected){
            heading.text(messages.both);
            heading.addClass('paypo-selected');
        } else {
            heading.text(messages.invoice);
            heading.removeClass('paypo-selected');
        }
        companyRow.forEach(el => el.classList.remove('is-hidden'))
        heading.show();
    } else {
        if(payPoSelected){
            heading.text(messages.paypo);
            heading.addClass('paypo-selected');
            heading.show();
        } else {
            heading.hide();
        }
        companyRow.forEach(el => el.classList.add('is-hidden'))
    }
}
jQuery(document).ready(() => handleInvoiceCheckbox());
if(invoiceElement) {
    invoiceElement.addEventListener('change', ( ) => {
        handleInvoiceCheckbox();
    })
}

jQuery(document.body).on('payment_method_selected', () => {
    handleInvoiceCheckbox();
});

// Phone number input
const phoneNumberInputs = document.querySelectorAll('input[type="tel"]');
if ( phoneNumberInputs.length ) {
    const initPhoneInput = (input) => {
        if ( typeof input !== 'object' ) {
            return;
        }

        const separator = '-';

        input.addEventListener('input', function (e) {
            const value = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/);

            const getSegment = (index) => {
                if ( index == 1 ) {
                    return `${value[index] ? value[index] : ''}`
                } else if ( index > 1 ) {
                    return `${value[index] ? `${separator}${value[index]}` : ''}`
                }
                
                return '';
            }

            e.target.value = `${getSegment(1)}${getSegment(2)}${getSegment(3)}${getSegment(4)}${getSegment(5)}`
        });
    };

    for ( let i = 0; i < phoneNumberInputs.length; i++ ) {
        const input = phoneNumberInputs[i];

        initPhoneInput(input);
    }
}

// Post code input
const postCodeInput = document.querySelector('#billing_postcode_field');

postCodeInput?.addEventListener('input', function (e) {
    const separator = '-';
    const value = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})/);

    const getSegment = (index) => {
        if (index == 1) {
            return `${value[index] ? value[index] : ''}`
        } else if (index > 1) {
            return `${value[index] ? `${separator}${value[index]}` : ''}`
        }

        return '';
    }

    e.target.value = `${getSegment(1)}${getSegment(2)}`
});

const nipInput = document.querySelector('#billing_nip_field');

nipInput?.addEventListener('input', function (e) {
    const value = e.target.value.replace(/\D/g, '')
    e.target.value = e.target.value.replace(/\D/g, '');
});

window.$ = jQuery;

const validatedCheckoutFields = '#billing_phone, #billing_email, #billing_email_repeat, #billing_postcode, #billing_first_name, #billing_last_name, #billing_nip, #billing_company, #billing_address_1, #billing_city';

$(validatedCheckoutFields).on('change focusout', function () {
    setTimeout(() => {
            if ($(this).parents('.form-row').hasClass('is-hidden') && !$(this).parents('.form-row').hasClass('paypo-visible')) {
                $(this).parents('.form-row').removeClass('woocommerce-invalid');
                return;
            }

            $(this).parents('.form-row').find('.checkout-error').remove();
            const regex = new RegExp($(this).data('pattern'));

            if (!regex.test($(this).val()) || $(this).val() === ''
                || ($(this)[0].id === 'billing_nip' && !isValidNip($(this).val()))
                || $(this)[0].id === 'billing_email_repeat' && $(this).val() !== $('#billing_email').val()
            ) {

                const $error = `<span class="checkout-error">${$(this).data('invalid-message')}</span>`;

                $(this).parents('.form-row').addClass('dnnz-invalid');
                $(this).parents('.form-row').removeClass('woocommerce-validated');
                $(this).after($error);

            } else {
                $(this).parents('.form-row').removeClass('dnnz-invalid');
            }

            if( $(this)[0].id === 'billing_email' && $('#billing_email_repeat').val() !== '' ) {
                $('#billing_email_repeat').trigger('focusout');
            }
        }, 100
    )
});

$(document).ready(function () {
    $(validatedCheckoutFields).each(function () {
        if ($(this).val() !== '') {
            $(this).trigger('focusout');
        }
    })

    $('#billing_email_repeat').bind('copy paste', function(e) {
        e.preventDefault();
    });
});

function isValidNip(nip) {
    if (typeof nip !== 'string' || nip === '0000000000')
        return false;

    nip = nip.replace(/[\ \-]/gi, '');

    let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    let controlNumber = parseInt(nip.substring(9, 10));
    let weightCount = weight.length;
    for (let i = 0; i < weightCount; i++) {
        sum += (parseInt(nip.substr(i, 1)) * weight[i]);
    }

    return sum % 11 === controlNumber;
}

$(document).ready(function () {
    setInterval(function () {

        const targetDate = new Date($('.site-info').data('datetime'));
        const counter = getTimeDiff(targetDate);

        $('.site-info .counter-days .counter-value').text(padZero(counter.days));
        $('.site-info .counter-hours .counter-value').text(padZero(counter.hours));
        $('.site-info .counter-minutes .counter-value').text(padZero(counter.minutes));
        $('.site-info .counter-seconds .counter-value').text(padZero(counter.seconds));
        $('.site-info-counters').addClass('visible');
    }, 1000);

    function padZero(num) {
        return num.toString().padStart(2, '0');
    }

    function getTimeDiff(targetDate) {
        const now = new Date();
        let timeDiff = targetDate.getTime() - now.getTime();
        if( $('.site-info').data('type') === 'auto_reset' && timeDiff <= 0 ) {
            const days_to_add = ($('.site-info').data('reset-type') === 'daily') ? 1 : 7;
            targetDate.setDate(targetDate.getDate() + days_to_add);
            timeDiff = targetDate.getTime() - now.getTime();
        }
        
        if (timeDiff <= 0) {
            return {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
            }
        } else {
            return {
                days: Math.floor(timeDiff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((timeDiff % (1000 * 60)) / 1000),
            }
        }
    }

    function adjustnavigationOffset() {
        const siteHeader = $( '.site-header' )[0];
        const siteInfo = $( '.site-info' )[0];
        let siteInfoOffset = 0;

        let scrollTop = window.scrollY || document
            .documentElement.scrollTop;
        if (scrollTop === 0) {
            siteInfoOffset = siteInfo?.clientHeight ?? 0;
        }

        const offset = siteInfoOffset + siteHeader.clientHeight;

        $( '.site-header__navigation.mm-menu--theme-white' ).css( 'margin-top', offset + 'px' );
    }

    $( window ).on( "scroll", adjustnavigationOffset );
    adjustnavigationOffset();

});

$(document.body).on('updated_checkout', function () {
    $('#shop_rules, #privacy_policy').on('change', function () {

        const bothChecked = $('#shop_rules').prop('checked') && $('#privacy_policy').prop('checked');

        if (bothChecked) {
            $('.ppc-button-wrapper').addClass('enabled');
        } else {
            $('.ppc-button-wrapper').removeClass('enabled');
        }

    });

    $('.ppc-button-wrapper').on('click', function (e){
        e.preventDefault();
        $( this ).parents('form.woocommerce-checkout').trigger( 'submit' );
    })

    $('#check_all').on('change', function(){
        $(this).parents('.form-row.place-order').find('input[type="checkbox"]').prop('checked', $(this).is(':checked'));
    })
});

(function($) {
    if (document.cookie.includes('wordpress_logged_in_')) {
        $('#login-button span').text('Twoje konto');
        $('#login-button').addClass('has-account-icon');
        setTimeout(function(){
            $('.mmenu-account').text('Twoje konto').addClass('has-account-icon');

        }, 500);
    }

    const items_in_cart = getCookie('woocommerce_items_in_cart');
    const counter = $('<span id="count-products-cart" class="counter is-visible">' + items_in_cart + '</span>');
    $('#mini-cart-open').append(counter);
})(jQuery);

function handleIframeMessage(event) {
    const paypoIframe = document.querySelector('#paypoIframe');
    if(!paypoIframe) return;
    let eventData = event.data;
    let isPageHeightSet = false;

    if (typeof eventData === "string") {
        try {
            eventData = JSON.parse(eventData);
        } catch (error) {
            console.error("Error parsing event data:", error);
            return;
        }
    }

    if (typeof eventData === "object" && eventData !== null) {
        if ('pageBodyHeight' in eventData) {
            paypoIframe.style.height = eventData.pageBodyHeight + 'px';
            isPageHeightSet = true;
            window.removeEventListener('message', handleIframeMessage);
        } else {
            isPageHeightSet || (paypoIframe.style.height = '5200px');
        }
    }
}
window.addEventListener('message', handleIframeMessage);

function sendReadyMessage() {
    var iframe = document.getElementById('paypoIframe');
    iframe?.contentWindow.postMessage({
        messageType: 'parentReady'
    }, "https://start.paypo.pl/");
}
window.onload = sendReadyMessage;

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

let wpcf7_submit_timeout;
$('.wpcf7-submit').on('click', function (e){
    if(wpcf7_submit_timeout) {
        e.preventDefault();
        return;
    }

    wpcf7_submit_timeout = setTimeout(function (){
        wpcf7_submit_timeout = null;
    }, 500);
});

(function ($) {
    $(document).on('facetwp-loaded', function () {
        if (FWP.loaded) { // Run only after the initial page load
            let scrollTop = 0;
            if ($('.metamorphosis-archive__header').length > 0) {
                scrollTop = $('.metamorphosis-archive__header')?.offset().top;
            }

            if ($('.search__input').length > 0) {
                scrollTop = $('.search__input')?.offset().top;
            }

            $('html, body').animate({
                scrollTop: scrollTop // Scroll to the top of the element with class "facetp-template"
            }, 250);
        }
    });
})(jQuery);